import './styles.scss';
import { Link, useLocation } from 'react-router-dom';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllBlogs, getBlogById, getBlogBySlug } from './detailedBlogApi';
import BackButton from '../../assets/Icons/arrow-back.png'
import { Helmet } from 'react-helmet'

const DetailedBlogPage = () => {
  const location = useLocation();
  const [spanContents, setSpanContents] = useState([]);
  const [numbers, setNumbers] = useState([]);
  const [clickedIndex, setClickedIndex] = useState(null);
  const navigate = useNavigate();

  const [blogDataById, setBlogDataById] = useState([])
  const [blogs, setBlogs] = useState([])
  const [sanitizedContent, setSanitizedContent] = useState('');
  const getpath = (path) => {//on new tab
    if (path) {
      const newPath = path.replace('/blog/', '');
      return newPath
    }
    else {
      return ''
    }
  }

  useEffect(() => {

    const getBlogDet = async () => {
      try {
        const { data } = await getBlogBySlug(location.state?.itemId ? location.state?.itemId : getpath(location?.pathname));
        setBlogDataById(data.data);
        console.log(blogDataById);

      } catch (err) {
        console.log(err, "err");
      }
    };
    // if (location?.state?.itemId) {
    getBlogDet();
    // }
  }, [location.state?.itemId]);
  let text = ''

  const setMetaTags = useCallback((data = '', title) => {

    let headers = {
      title: '',
      links: [],
      metaData: [],
      script: '',
    }
    headers.h1Tag = title
    data = data.replace(/\\n/g, '')
    data = data.split('\n')
    data.forEach((el) => {
      if (el.includes('<meta') || el.includes('<link')) {
        let obj = {}
        let regExp = /(\S+)="[^"]*/g
        let regexMatches = el.match(regExp)

        regexMatches.map(el => {
          let partition = el.split('="')
          obj[partition[0]] = partition[1].replace(/"/g, '')
        })

        if (el.includes('<meta'))
          headers.metaData.push(obj)
        if (el.includes('<link'))
          headers.links.push(obj)
      }
      else if (el.includes('<title'))
        // headers.title = el.replace('<title>','').replace('</title>','')
        if (headers) {
          headers.title = el.replace('<title>', '').replace('</title>', '');
        }
        else if (el.includes('<script'))
          headers.script = el

    })
    text = headers?.title.trim()
    return <Helmet title={`${headers?.title.trim()}`} meta={headers?.metaData} />

  }, [location.state?.itemId])

  const removeHtmlTags = (htmlString) => {
    const tempElement = document.createElement("div");
    tempElement.innerHTML = htmlString;
    return tempElement.textContent || tempElement.innerText || "";
  };

  const formatDate = (dateString) => {
    const dateObject = new Date(dateString);
    return dateObject.toLocaleDateString("en-US", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
  };
  const scrollToContent = (number, index) => {
    const elements = document.querySelectorAll('.blog-content h6');
    setClickedIndex(index);

    elements.forEach((element) => {
      if (element.innerText.includes(number)) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });

      }
    });
  };

  useEffect(() => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(blogDataById.content, 'text/html');
    const removeStyles = (element) => {
      if (element.hasAttribute('style')) {
        element.removeAttribute('style')
      }
      for (let child of element.children) {
        removeStyles(child)
      }
    }

    const extractSpanContents = (element) => {
      if (element.tagName.toLowerCase() === 'h6' && /^\d/.test(element.innerText.trim())) {
        const contentWithoutNumber = element.innerText.trim().replace(/[\d.,()]/g, '');
        const number = element.innerText.trim().match(/^\d+/)[0];
        if (!spanContents.includes(contentWithoutNumber)) {
          setSpanContents((prevContents) => [...prevContents, contentWithoutNumber]);
        }
        if (number && !numbers.includes(number)) {
          setNumbers((prevNumbers) => [...prevNumbers, number]);
        }

      } else
        if (element.hasAttribute('style')) {
          element.removeAttribute('style');
        }

      for (let child of element.children) {
        extractSpanContents(child);

      }

    }


    extractSpanContents(doc.body)
    removeStyles(doc.body)

    setSanitizedContent(doc.body.innerHTML)
  }, [blogDataById.content])

  const getBlogs = async () => {
    try {
      const { data } = await getAllBlogs();
      setBlogs(data.data)
    }
    catch (err) {
      console.log(err, 'err')
    }
  }

  useEffect(() => {
    getBlogs()

  }, [])
  const filteredBlogs = blogs.filter(item => item._id !== location.state?.itemId);

  return (
    <>
      {setMetaTags(blogDataById?.meta, blogDataById?.title)}

      <div className='details-container'>
        <div className='left-sec'>
          <div className='head' style={{ color: clickedIndex === null ? '#1C3879' : '#8C8C8C' }} >Summary</div>
          {spanContents.map((content, index) => (
            <div key={index} className={`span-content ${clickedIndex === index ? 'clicked' : ''}`} id={`spanContent-${index}`}
              onClick={() => scrollToContent(numbers[index], index)} >{content}</div>
          ))}
        </div>
        <div className='right-sec'>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <p className='heading'>{blogDataById.title}</p>
            <span className='heading-btn' onClick={() => (navigate('/blog'))}><img src={BackButton} /></span>
          </div>
          <img src={blogDataById.coverImage} className='detailed-image' />
          <div className='blog-content' dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
          <div className='related-blog'>
            <div className='head'>Related Blog</div>
            <div className="daily-blogs">
              {filteredBlogs.slice(0, 4).map((item) => (
                <Link to={`/blog/${item.slug}`} state={{ itemId: item.slug }} style={{ textDecoration: 'none' }} onClick={(e) => {
                  setTimeout(() => window.location.reload(), 100)
                }}>
                  <div className="blogs-sec" key={item._id} >
                    <img
                      src={item.coverImage}
                      alt="Featured images"
                      className="cover-image"
                    />
                    <div className="content">
                      <div className="feature-head">{item.title}</div>
                      <div className="main-content">
                        {removeHtmlTags(item.content)}
                      </div>
                      <div className="date">{formatDate(item.createdAt)}</div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DetailedBlogPage;